import Vue from 'vue'
import VueMq from 'vue-mq'

export default async function () {
  const moduleOptions = {"breakpoints":{"mobileSmall":425,"mobile":768,"tablet":992,"laptop":1200,"desktop":null},"defaultBreakpoint":"desktop"}
  Vue.use(VueMq, moduleOptions)
}
